<span [translateParams]="{
        used: used,
        available: available
     }"
      translate>
    <ng-container *ngIf="consumerType === licenseConsumerType.Device; else perUser">
        <ng-container *ngIf="used === 1; then singleDevice else multipleDevices">
        </ng-container>
    </ng-container>

    <ng-template #perUser>
        <ng-container *ngIf="consumerType === licenseConsumerType.User; else perConnection">
            <ng-container *ngIf="used === 1; then singleUser else multipleUsers">
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #perConnection>
        <ng-container *ngIf="used === 1; then singleConnection else multipleConnections">
        </ng-container>
    </ng-template>
</span>

<ng-template #singleConnection>
    settings_license_value_connections_single
</ng-template>

<ng-template #multipleConnections>
    settings_license_value_connections_multiple
</ng-template>

<ng-template #singleUser>
    settings_license_value_users_single
</ng-template>

<ng-template #multipleUsers>
    settings_license_value_users_multiple
</ng-template>

<ng-template #singleDevice>
    settings_license_value_devices_single
</ng-template>

<ng-template #multipleDevices>
    settings_license_value_devices_multiple
</ng-template>
